import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { PageTitle } from "@/components/ui/PageTitle";
import { QuickActions } from "@/components/poultry/QuickActions";
import { PoultryInventory } from "@/components/poultry/PoultryInventory";
import { AddProductDialog } from "@/components/interface/AddProductDialog";
import { TransactionDialog } from "@/components/poultry/TransactionDialog";
import { ReturnDialog } from "@/components/poultry/ReturnDialog";
import { LossDialog } from "@/components/poultry/LossDialog";
import { usePoultryTransactions } from "@/hooks/usePoultryTransactions";

const Poultry = () => {
  const {
    isAddDialogOpen,
    setIsAddDialogOpen,
    isTransactionDialogOpen,
    setIsTransactionDialogOpen,
    isReturnDialogOpen,
    setIsReturnDialogOpen,
    isLossDialogOpen,
    setIsLossDialogOpen,
    selectedItem,
    transactionType,
    stockItems,
    handleAddProduct,
    handleLossClick,
    handleReturnClick,
    handleLossConfirm,
    handleReturnConfirm
  } = usePoultryTransactions();

  return (
    <DashboardLayout userType="owner">
      <div className="space-y-6">
        <PageTitle
          title="Gestion de la ferme avicole"
          subtitle="Gérez votre élevage et votre production"
        />

        <QuickActions 
          onAddTransaction={() => setIsTransactionDialogOpen(true)}
          onAddPoultry={() => setIsAddDialogOpen(true)}
        />
        
        <PoultryInventory 
          onLossClick={handleLossClick}
          onReturnClick={handleReturnClick}
        />

        <AddProductDialog
          isOpen={isAddDialogOpen}
          onOpenChange={setIsAddDialogOpen}
          onSubmit={handleAddProduct}
          isPoultry={true}
        />

        <TransactionDialog
          isOpen={isTransactionDialogOpen}
          onOpenChange={setIsTransactionDialogOpen}
          transactionType={transactionType}
          onSuccess={() => {}}
        />

        {selectedItem && (
          <>
            <ReturnDialog
              open={isReturnDialogOpen}
              onOpenChange={setIsReturnDialogOpen}
              selectedProduct={selectedItem}
              onConfirm={handleReturnConfirm}
            />
            <LossDialog
              open={isLossDialogOpen}
              onOpenChange={setIsLossDialogOpen}
              stockItems={stockItems || []}
              onConfirm={handleLossConfirm}
            />
          </>
        )}
      </div>
    </DashboardLayout>
  );
};

export default Poultry;